exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div>*[data-v-50efbfa2]{margin-right:10px}div[data-v-50efbfa2]>:last-child{margin-right:0}", ""]);

// exports
